/** @jsxImportSource @emotion/react */

import type { Interpolation } from "@emotion/react";
import type { ThemeType } from "@packages/ui";
import type { HTMLMotionProps } from "motion/react";
import { motion } from "motion/react";

import { Durations } from "../../lib/enums/durations";
import { ZIndices } from "../../lib/enums/zIndices";

const cssDialogOverlay: Interpolation<ThemeType> = (theme) => ({
  backgroundColor: theme.shades.shade40,
  inset: 0,
  position: "fixed",
  zIndex: ZIndices.Overlay,
});

export const Overlay = (props: HTMLMotionProps<"div">) => (
  <motion.div
    animate={{ opacity: 1 }}
    css={cssDialogOverlay}
    exit={{ opacity: 0 }}
    initial={{ opacity: 0 }}
    transition={{
      duration: Durations.Short,
    }}
    {...props}
  />
);
